import { useDispatch, useSelector } from 'react-redux'
import { RootState, Subtask } from 'constants/interfaces'
import { AppDispatch } from 'config/redux'
import keys from 'constants/keys'
import { updateResults } from 'redux/actions/tasks_v2'
import { getFileExtension, openInCloudViewer } from 'utils'
import { getFormattedLink } from '../utils'
import { useTaskOverviewContext } from '../TaskOverviewStackProvider'
import { findScopedResult, isResultCompleted } from '../model/results'

export function useExecutionLink(subtask: Subtask) {
  const { resultContextId, isReadMode, task } = useTaskOverviewContext()
  const dispatch: AppDispatch = useDispatch()
  const config = useSelector((state: RootState) => state.config)
  const { tasks, userResults, allResults } = useSelector((state: RootState) => state.tasks_v2)
  const uid = useSelector((state: RootState) => state.auth.uid)

  return () => {
    if (isReadMode || !subtask.external_link) return
    const { tags, first_name, last_name, default_group, groups, rid } = config.config
    const url = getFormattedLink({
      link: subtask.external_link,
      tasks,
      task,
      tid: subtask.tid,
      st_id: subtask.st_id,
      contextId: resultContextId,
      uid: uid!,
      userResults,
      tags,
      first_name,
      last_name,
      default_group,
      groups,
      activeGroupID: config.activeGroupID!,
      rid,
    })
    window.open(
      keys.extensionsForCloudViewer.includes(getFileExtension(url)) ? openInCloudViewer(url) : url,
      '_blank',
      'noopener,noreferrer'
    )
    const result = findScopedResult(allResults?.[subtask.tid], subtask.st_id, resultContextId, task.recurrence_ts)
    if (subtask.is_external_status_update && !isResultCompleted(result))
      dispatch(
        updateResults({
          tid: subtask.tid,
          st_id: subtask.st_id,
          type: subtask.type,
          resultContextId,
          recurrence_ts: task.recurrence_ts,
          status: keys.TASK_STATUSES.DONE.value,
        })
      )
    // Integrated links own their completion callback. Opening only marks local progress.
    if (!subtask.is_external_status_update && !isResultCompleted(result))
      dispatch(
        updateResults({
          tid: subtask.tid,
          st_id: subtask.st_id,
          type: subtask.type,
          resultContextId,
          recurrence_ts: task.recurrence_ts,
          isExternalLink: true,
          status: keys.TASK_STATUSES.INPROGRESS.value,
        })
      )
  }
}
